<template>
  <div>
    <div>
      <p></p>
      <strong><T>Типы доставки</T></strong>
      <div v-for="key in deliveryKeys" :key="key">
        <CheckBox
          class="ml-4"
          :label="getLabel(key)"
          :hint="getHint(key)"
          :original_value="config[key]"
          v-model="local_config[key]"
        />
      </div>
    </div>

    <div class="mt-4">
      <strong><T>Типы оплат</T></strong>
      <div v-for="key in paymentKeys" :key="key">
        <CheckBox
          class="ml-4"
          :label="getLabel(key)"
          :hint="getHint(key)"
          :original_value="config[key]"
          v-model="local_config[key]"
        />
      </div>
    </div>
  </div>
</template>

<script>
import settings_group_mixin from '../settings_group_mixin'
import CheckBox from '../../common/CheckBox.vue'

export default {
  mixins: [settings_group_mixin],
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      local_loading: false,
      locales: [],
      local_config: {},
      deliveryKeys: ['allow_delivery', 'allow_pickup'],
      paymentKeys: ['allow_pay_card_offline', 'allow_pay_card_online', 'allow_pay_cash']
    }
  },
  watch: {
    local_config: {
      handler(newVal) {
        this.$emit('configChanged', newVal)
      },
      deep: true
    }
  },
  computed: {
    checkboxLabels() {
      return {
        allow_delivery: this.$t('Разрешить доставку'),
        allow_pay_card_offline: this.$t('Разрешить оплату картой при получении'),
        allow_pay_card_online: this.$t('Разрешить оплату картой онлайн'),
        allow_pay_cash: this.$t('Разрешить оплату наличными'),
        allow_pickup: this.$t('Разрешить самовывоз')
      }
    },
    checkboxHints() {
      return {
        allow_delivery: this.$t('Заказ будет доставлен курьером'),
        allow_pay_card_offline: this.$t('Заказы можно оплачивать картой при получении заказа от курьера'),
        allow_pay_card_online: this.$t('Заказы можно оплачивать картой онлайн при оформлении заказа'),
        allow_pay_cash: this.$t('Оплата производится наличными курьеру'),
        allow_pickup: this.$t('Заказы можно забирать самостоятельно из ресторана')
      }
    },
    any_loading() {
      return this.local_loading
    }
  },
  created() {
    this.local_config = { ...this.config }
  },
  methods: {
    getLabel(key) {
      return this.checkboxLabels[key] || key
    },
    getHint(key) {
      return this.checkboxHints[key] || ''
    },
    async loadLocales() {
      this.local_loading = true
      try {
        this.locales = await this.$store.dispatch('getAvailableLocales')
      } finally {
        this.local_loading = false
      }
    },
    submit() {
      return this.local_config
    }
  },
  mounted() {
    this.loadLocales()
  },
  components: {
    CheckBox
  }
}
</script>
